import React, { createContext, useState, useEffect } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import {firebaseApp} from "../firebase/firebase";

// Tworzymy kontekst z domyślnymi wartościami
export const AuthContext = createContext({
    user: null,
    loading: true,
});

// Provider opakowujący aplikację
export const AuthProvider = ({ children }) => {
    const auth = getAuth(firebaseApp);
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    // Ustawiamy listener przy starcie aplikacji
    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
            setUser(firebaseUser); // Jeśli firebaseUser jest null, oznacza to, że użytkownik jest wylogowany
            setLoading(false);
        });

        // Cleanup listenera przy odmontowaniu komponentu
        return () => unsubscribe();
    }, [auth]);

    return (
        <AuthContext.Provider value={{ user, loading }}>
            {children}
        </AuthContext.Provider>
    );
};
